/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnectionScheduleSitesConfig } from './ICRTouchConnectionScheduleSitesConfig';
import {
    ICRTouchConnectionScheduleSitesConfigFromJSON,
    ICRTouchConnectionScheduleSitesConfigFromJSONTyped,
    ICRTouchConnectionScheduleSitesConfigToJSON,
    ICRTouchConnectionScheduleSitesConfigToJSONTyped,
} from './ICRTouchConnectionScheduleSitesConfig';

/**
 * 
 * @export
 * @interface CreateIcrTouchConnectionScheduleSitesConfigResponse
 */
export interface CreateIcrTouchConnectionScheduleSitesConfigResponse {
    /**
     * 
     * @type {ICRTouchConnectionScheduleSitesConfig}
     * @memberof CreateIcrTouchConnectionScheduleSitesConfigResponse
     */
    data: ICRTouchConnectionScheduleSitesConfig;
}

/**
 * Check if a given object implements the CreateIcrTouchConnectionScheduleSitesConfigResponse interface.
 */
export function instanceOfCreateIcrTouchConnectionScheduleSitesConfigResponse(value: object): value is CreateIcrTouchConnectionScheduleSitesConfigResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateIcrTouchConnectionScheduleSitesConfigResponseFromJSON(json: any): CreateIcrTouchConnectionScheduleSitesConfigResponse {
    return CreateIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json, false);
}

export function CreateIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIcrTouchConnectionScheduleSitesConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigFromJSON(json['data']),
    };
}

  export function CreateIcrTouchConnectionScheduleSitesConfigResponseToJSON(json: any): CreateIcrTouchConnectionScheduleSitesConfigResponse {
      return CreateIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(json, false);
  }

  export function CreateIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(value?: CreateIcrTouchConnectionScheduleSitesConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigToJSON(value['data']),
    };
}

